(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-360-viewer"] && !Shopify.designMode) return;
  try {
    

function initializeProduct360Viewers() {

  document
    .querySelectorAll('[data-product-360]')
    .forEach(function (container) {

      if (container.dataset.initialized === 'true') {
        return;
      }

      container.dataset.initialized = 'true';

      const viewer =
        container.querySelector('.product-360__viewer');

      const image =
        container.querySelector('.product-360__image');

      const currentLabel =
        container.querySelector('.product-360__current');

      const playButton =
        container.querySelector('.product-360__play');

      const dragMessage =
        container.querySelector('.product-360__drag');

      const frameElements =
        container.querySelectorAll(
          '.product-360__frames [data-src]'
        );

      const frames =
        Array.from(frameElements).map(function (element) {
          return element.dataset.src;
        });

      if (!viewer || !image || frames.length < 2) {
        return;
      }

      frames.forEach(function (src) {
        const preload = new Image();
        preload.src = src;
      });

      let currentFrame = 0;
      let dragging = false;
      let startX = 0;
      let startFrame = 0;
      let autoRotate = null;
      let dragMessageHidden = false;

      function showFrame(frameNumber) {

        currentFrame =
          ((frameNumber % frames.length) + frames.length)
          % frames.length;

        image.src = frames[currentFrame];

        if (currentLabel) {
          currentLabel.textContent = currentFrame + 1;
        }
      }

      function getPointerX(event) {

        if (event.touches && event.touches.length) {
          return event.touches[0].clientX;
        }

        return event.clientX;
      }

      function hideDragMessage() {

        if (dragMessage && !dragMessageHidden) {
          dragMessage.style.display = 'none';
          dragMessageHidden = true;
        }
      }

      function stopAutoRotate() {

        if (!autoRotate) {
          return;
        }

        clearInterval(autoRotate);
        autoRotate = null;

        if (playButton) {
          playButton.textContent = '▶ Auto Rotate';
        }
      }

      function startDrag(event) {

        stopAutoRotate();
        hideDragMessage();

        dragging = true;
        startX = getPointerX(event);
        startFrame = currentFrame;
      }

      function drag(event) {

        if (!dragging) {
          return;
        }

        const distance =
          getPointerX(event) - startX;

        const frameChange =
          Math.round(distance / 18);

        showFrame(
          startFrame - frameChange
        );
      }

      function stopDrag() {
        dragging = false;
      }

      viewer.addEventListener(
        'mousedown',
        startDrag
      );

      window.addEventListener(
        'mousemove',
        drag
      );

      window.addEventListener(
        'mouseup',
        stopDrag
      );

      viewer.addEventListener(
        'touchstart',
        startDrag,
        { passive: true }
      );

      viewer.addEventListener(
        'touchmove',
        drag,
        { passive: true }
      );

      viewer.addEventListener(
        'touchend',
        stopDrag
      );

      if (playButton) {

        playButton.addEventListener(
          'click',
          function () {

            hideDragMessage();

            if (autoRotate) {
              stopAutoRotate();
              return;
            }

            playButton.textContent =
              '❚❚ Pause';

            autoRotate =
              setInterval(
                function () {
                  showFrame(
                    currentFrame - 1
                  );
                },
                150
              );
          }
        );
      }

      showFrame(0);

    });
}

document.addEventListener(
  'DOMContentLoaded',
  initializeProduct360Viewers
);

document.addEventListener(
  'shopify:section:load',
  initializeProduct360Viewers
);


  } catch(e) { console.error(e); }
})();
})();
